import Picture from 'components/Picture';
import style from './style.module.scss';
import {Typography} from 'components/Typography';
import cs from 'classnames';
import {IReviewAuthor} from 'modules/product-card/models/Review';

export interface IProps extends Partial<IReviewAuthor> {
    className?: string;
}

export const Avatar = ({personalPhoto, userInitials, className}: IProps) => {
    return (
        <div className={cs(style.avatar, className)}>
            {personalPhoto ? (
                <Picture alt={'avatar'} sources={{}} src={personalPhoto} />
            ) : (
                <Typography className={style.userName}>{userInitials}</Typography>
            )}
        </div>
    );
};
